/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  let spImgList = [
    "https://cdn.shopify.com/s/files/1/0770/3353/7761/files/20250919-pr1.png",
    "https://cdn.shopify.com/s/files/1/0770/3353/7761/files/20250919-pr2.png",
    "https://cdn.shopify.com/s/files/1/0770/3353/7761/files/20250919-pr3.png",
    "https://cdn.shopify.com/s/files/1/0770/3353/7761/files/20250919-pr4.png",
    "https://cdn.shopify.com/s/files/1/0770/3353/7761/files/20250919-pr5.png",
    "https://cdn.shopify.com/s/files/1/0770/3353/7761/files/20250919-p1.png",
    "https://cdn.shopify.com/s/files/1/0770/3353/7761/files/20250919-p2.png",
    "https://cdn.shopify.com/s/files/1/0770/3353/7761/files/20250919-p3.png",
    "https://cdn.shopify.com/s/files/1/0770/3353/7761/files/20250919-p4.png",
    "https://cdn.shopify.com/s/files/1/0770/3353/7761/files/20250919-p5.png",

    "https://cdn.shopify.com/s/files/1/0770/3353/7761/files/20250919-b1.png",
    "https://cdn.shopify.com/s/files/1/0770/3353/7761/files/20250919-b2.png",
    "https://cdn.shopify.com/s/files/1/0770/3353/7761/files/20250919-b3.png",
  ];
  new Swiper(".sp-swiper", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 4000,
    },
    loop: true,
  });
  new Swiper(".sp-swiper2", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    loop: true,
    spaceBetween: 30,
    slidesPerView: "auto",
    centeredSlides: true,
  });
  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");

      let scale = document.body.clientWidth / 1080;
      $("#root").css("zoom", scale);

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              let scale = document.body.clientWidth / 1080;
              $("#root").css("zoom", scale);
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        let _topHeight =
          $(".time-part").height() + $(".sp-header-top").height() - 30;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            _topHeight * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

    var links = document.querySelectorAll('a[href^="#add-cart"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('add-cart');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("add-cart"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        let _topHeight =
          $(".time-part").height() + $(".sp-header-top").height() - 30;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            _topHeight * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();

  $(".product-box .sp-opt").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    let _index = $(this).index();

    $(this)
      .parents(".product-box")
      .find(".sp-p-img")
      .eq([_index])
      .show()
      .siblings(".sp-p-img")
      .hide();
  });

  let pop_num = 0; // 显示第几个弹窗

  // 点击选择按钮
  $(".product-box .buy2").click(function () {
    pop_num = $(this).parents(".product-box").attr("data-index");

    $(".sp-mask").css("display", "flex");
    $(".sp-pop").eq(pop_num).show().siblings(".sp-item").hide();
  });
  // 关闭弹窗按钮
  $(".sp-mask").click(function (e) {
    if ($(e.target).closest(".sp-mask .btn-style,.sp-pop").length > 0) {
    } else {
      $(".sp-mask,.sp-pop").hide();
      // 恢复默认
      pop_num = 0;
    }
  });

  $(".sp-pop .sp-opt").click(function () {
    let _index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    let cur_index = $(this).parents(".sp-item").attr("data-index");

    $(".sp-pop").eq(pop_num).find(".img-pop .sp-img").eq(cur_index)[0].src =
      spImgList[_index];
  });

  $('.sp-btn-style.buy1').click(function(){
    let id = $(this).siblings('.sp-opt-group').find('.active').attr('data-id');
    window.location.href = '/cart/' + id + ':' + 1;
  })
  $('.sp-pop .btn-style').click(function(){
    let value = $(this).attr("data-value");
    if(value == 2){
        let id1 = $(".sp-pop").eq(0).find('.sp-item').eq(0).find('.active').attr('data-id');
        let id2 = $(".sp-pop").eq(0).find('.sp-item').eq(1).find('.active').attr('data-id');
        window.location.href = `/cart/${id1}:1,${id2}:1`
    }else{
        let id1 = $(".sp-pop").eq(1).find('.sp-item').eq(0).find('.active').attr('data-id');  
        let id2 = $(".sp-pop").eq(1).find('.sp-item').eq(1).find('.active').attr('data-id');  
        let id3 = $(".sp-pop").eq(1).find('.sp-item').eq(2).find('.active').attr('data-id');
        let id4 = $(".sp-pop").eq(1).find('.sp-item').eq(3).find('.active').attr('data-id'); 
        window.location.href = `/cart/${id1}:1,${id2}:1,${id3}:1,${id4}:1`;
    }
    
  })

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }
});
